import styled from 'styled-components';

export const ImageGrayContainer = styled.img`
  position: fixed;
  bottom: -60px;
  width: 100%;

  @media (max-width: 550px) {
    width: auto;
  }
`;

export const ImageGreenContainer = styled.img`
  position: fixed;
  bottom: 0px;
  width: 100%;

  @media (max-width: 550px) {
    width: auto;
  }
`;

export const Shopname = styled.span`
  font-weight: 500;
  font-size: 18px;
  color: white;
  text-align: center;
  display: block;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (min-width: 400px) {
    max-width: 200px;
  }
  @media (min-width: 768px) {
    max-width: 600px;
  }
`;

export const BranchName = styled.label`
  font-weight: 600;
  font-size: 16px;
  color: white;
  display: block;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (min-width: 400px) {
    max-width: 200px;
  }
  @media (min-width: 768px) {
    max-width: 600px;
  }
`;

export const BranchNameWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
